import React from 'react';
import "./Home.css";
import midbanner from "../../assets/images/midbanner.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation , Pagination} from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const banner = [
    {
        id : 1,
        image : midbanner,
    },
    {
        id : 2,
        image : midbanner,
    },
    {
        id : 3,
        image : midbanner,
    },
];


function Midbanner({ homeSettings = {} }) {
  const displayBanner = (homeSettings.mid_banners && Array.isArray(homeSettings.mid_banners) && homeSettings.mid_banners.length > 0) 
    ? homeSettings.mid_banners 
    : banner;

  return (
    <div className='midbanner_section'>
      <div className="container-fluid">
      <div className="slider-wrapper">
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={30}
            slidesPerView={4}
            loop={true}
            autoplay={{ delay: 5500, disableOnInteraction: false }}
            navigation
            pagination={{ clickable: true }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              480: {
                slidesPerView: 1,
                spaceBetween: 5,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 15,
              },
            }}
          >
            {displayBanner.map((item, idx) => (
              <SwiperSlide key={item.id || idx}>
                <div className="midbanner_image" key={item.id}>
                  <img src={item.image} alt="" className='img-fluid' />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        </div>
    </div>
  )
}

export default Midbanner
